const PAGE_SIZE = 20;

class DonationsController {
  constructor($rootScope, Donation, toaster) {
    'ngInject';
    this.Donation = Donation;
    this.account = $rootScope.account;
    this.toaster = toaster;
    this.canReadDonations = $rootScope.user.can('read', 'donations:summary');
    if (!this.canReadDonations) {
      return;
    }

    this.loadingPromises = [];

    this.setTimePeriod(null); //start at "all time"
  }

  setTimePeriod(value) {
    // moment.month gives 0-11
    // we'll translate into quarter number 1-4
    var currentQuarterNumber = Math.ceil((moment().month() + 1) / 3);
    var startMonth = (currentQuarterNumber - 1) * 3;
    var endMonth = currentQuarterNumber * 3 - 1;

    if (value == 'this_q') {
      this.timePeriod = value;
      this.start = moment().month(startMonth).startOf('month').toDate();
      this.end = moment().month(endMonth).endOf('month').toDate();
    } else if (value == 'last_q') {
      this.timePeriod = value;
      this.start = moment().month(startMonth).subtract(3, 'months').startOf('month').toDate();
      this.end = moment().month(endMonth).subtract(3, 'months').endOf('month').toDate();
    } else {
      this.timePeriod = null;
      this.start = null;
      this.end = null;
    }
    this.loadDonationsForPage(1);
  }

  loadDonationsForPage(p) {
    const { Donation, account, toaster } = this;

    var q = undefined;
    if (this.start && this.end) {
      q = `created_at:[${this.start.toISOString()} TO ${this.end.toISOString()}]`;
    }

    var donations = Donation.query(
      {
        q: q,
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-created_at',
      },
      (data, headers) => {
        this.donations = data;
        var pagination = JSON.parse(headers('x-pagination'));
        this.donationsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length,
        };
      },
      (err) => {
        toaster.pop('warning', 'Unable to load donations. Please refresh the page and try again.');
      }
    );

    this.summary = Donation.summary({ q: q });

    this.loadingPromises.push(donations.$promise);
    this.loadingPromises.push(this.summary.$promise);
  }
}

export default DonationsController;



// WEBPACK FOOTER //
// ./app/pages/reports/donations.js